<template>
  <div :class="{ 'card': !nested }">
    <div :class="{ 'card-body': !nested }">
      <slot>
        <tasks-paginated
          view="today"
          :title="title"
          :hide-title="hideTitle"
          icon="fa-star"
          icon-color-class="text-flat-sunflower"
          :autoload="true"
          variant="narrow"
          :using-router="false"
          :hide-new-task-button="true"
        ></tasks-paginated>
      </slot>
      <hr>
      <div class="d-flex justify-content-between">
        <button
          v-if="!hideNewTaskButton"
          class="btn btn-primary btn-sm"
        >
          <i class="fa fa-plus mr-1"></i>
          New Task
        </button>
        <a
          href="/business-plan/tasks"
          class="ml-auto btn btn-sm btn-link text-decoration-none text-body"
        >
          See All Tasks
        </a>
      </div>
    </div>
  </div>
</template>

<style>

</style>

<script>
import $ from 'jquery'
import moment from 'moment'
import TasksPaginated from '@/components/TasksPaginated'

export default {
  components: {
    TasksPaginated
  },
  props: {
    title: {
      type: String,
      default () {
        return 'Today, ' + moment().format('MMM D')
      }
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    nested: {
      type: Boolean,
      default: false
    },
    hideNewTaskButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    createNewTask (options) {
      $(window).trigger('createNewTask.requested', [options])
    }
  }
}
</script>
